import { Component, OnInit, Input, ViewChildren, QueryList, ContentChildren } from '@angular/core';
import { PagedResultModel } from 'mm-web-core/common';
import { PagedTableColumnComponent } from '../paged-table-column/paged-table-column.component';

@Component({
  selector: 'mm-paged-table',
  templateUrl: './paged-table.component.html',
  styleUrls: ['./paged-table.component.scss']
})
export class PagedTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @ContentChildren(PagedTableColumnComponent, { descendants: true })
  columns: QueryList<PagedTableColumnComponent>

  @Input()
  pagedData: PagedResultModel<any>

  get data() {
    if (this.pagedData) return this.pagedData.data;
    return undefined;
  }


  isTemplate(data: any) {
    return typeof data !== "string";

  }


}
